import { Children } from 'react';

import { BoxProps, LinkSectionProps } from '../interface';
import { Box } from '../layout/Box';
import { Line } from '../line/Line';

export const LinkSection = ({
  children,
  lineProps,
  ...restProps
}: LinkSectionProps & BoxProps): JSX.Element => {
  return (
    <Box
      {...restProps}
      width={'100%'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      {
        Children.toArray(children).reduce((prev, curr, index) => [
          prev,
          <Line {...lineProps} key={index} margin={'0 16px'} isVertical />,
          curr,
        ]) as JSX.Element
      }
    </Box>
  );
};
